









































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CardForm, Send } from '@/components/bwaff';
import Form from '@/components/form-base';
import { pick } from 'lodash';
import DomainsApi from '@/services/rest/bemob/domains';

@Component({
  components: {
    CardForm
  }
})
export default class Root extends Form {
  form: {
    rootDomain:'redirect' | '404'
    rootRedirect: string
  } = {rootDomain:null,rootRedirect:null};
  loading: boolean = false;
  error: boolean = false;
  domainsApi: DomainsApi = new DomainsApi();

  @Send()
  submit() {
    this.loading = true;
    return this.domainsApi.updateUserDomainData(this.form).then((res: any) => {
      this.$store.commit('updateUser', res);
      this.error = false;
      this.bus.emit('toast-success', this.t('Tracking Domain’s Destination has been changed'));
    }).catch((e: any) => {
      this.error = e.response.data.message === 'VALIDATION_FAILED';
    }).finally(()=>this.loading = false);
  }

  fillForm(source: any) {
    this.form = {
      ...this.form,
      ...pick(source, [
        'rootDomain',
        'rootRedirect'
      ])
    };

  }

  mounted() {
    this.fillForm(this.$store.state.user);
  }

  @Watch('$store.state.user')
  user_changed(data: any) {
    this.fillForm(data);
  }
}
